// extracted by mini-css-extract-plugin
export default {"root":"ChangelogContent_root__j5QeW"};